// @flow
import * as React from "react";
import { withColorsProvider, type ColorSet } from "../ColorsProvider";
import prefixStyles from "../utils/prefixStyles";
import type { StylesObject } from "../utils/prefixStyles";
import Theme from "../Theme";
import NoStyleButton from "../NoStyleButton";
import SelectWithoutTappable from "../Select/SelectWithoutTappable";
import type { valueType, Option } from "../Select/SelectDialog";
import Tappable, { simpleActiveBackgroundColor } from "../Tappable";
import InfoIcon from "../Form/fields/FormFieldIcons/InfoIcon";

type Props = {
  onChange: (valueType) => void,
  label: string,
  placeholder?: ?boolean,
  infoIcon?: ?boolean,
  infoText?: ?string,
  options: Array<Option>,
  value: ?valueType,
  onOptionTapped?: ?(Option) => void,
  onBackgroundTapped?: ?() => void,
  onRequestClose?: ?() => void,
  labelStyle?: ?StylesObject,
  style?: ?StylesObject,
  colors: ColorSet,
  isPivot?: ?boolean,
};

type State = {
  open: boolean,
};

class SelectItem extends React.Component<Props, State> {
  state = { open: false };

  toggleOpen = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  };

  handleOptionTapped = (option: Option) => {
    if (this.props.onChange) {
      this.props.onChange(option.value);
    }
    this.toggleOpen();
  };

  render() {
    const {
      label,
      placeholder,
      infoIcon,
      infoText,
      colors,
      ...props
    } = this.props;

    const { open } = this.state;

    const styles = prefixStyles({
      outerWrapper: {
        display: "flex",
        alignItems: "center",
      },
      wrapper: {
        marginLeft: "0",
        marginRight: "0",
        position: "relative",
        color: colors.TEXT,
        width: "100%",
        textAlign: "left",
        flexGrow: "1",
        flexBasis: "100%",
      },
      container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: "pointer",
      },
      label: {
        color: colors.TEXT,
        display: "flex",
        flexGrow: "1",
        flexShrink: "0",
        flexBasis: "66%",
        paddingRight: "0.75em",
        outline: "none",
      },
      selectWrapper: {
        color: colors.TEXT,
        ...Theme.Styles.flexShrink,
        verticalAlign: "baseline",
      },
      select: {
        width: "100%",
        fontSize: "0.8em",
        textTransform: "uppercase",
      },
      infoIconWrapper: {
        paddingLeft: "0.25em",
        display: "inline-flex",
      },
    });

    return (
      <Tappable onTap={this.toggleOpen}>
        {({ active, tapTargetRefHandler }) => {
          return (
            <div style={styles.outerWrapper}>
              <NoStyleButton
                style={{
                  ...styles.wrapper,
                  backgroundColor: simpleActiveBackgroundColor(active),
                }}
                innerRef={tapTargetRefHandler}
              >
                <div style={styles.container}>
                  {!placeholder ? (
                    <span
                      style={{
                        ...styles.label,
                        flexBasis: this.props.isPivot ? "33%" : "66%",
                      }}
                      aria-label={`${label}:`}
                    >
                      {label}
                    </span>
                  ) : null}
                  <div style={styles.selectWrapper}>
                    <SelectWithoutTappable
                      placeholder={placeholder ? label : null}
                      open={open}
                      style={styles.select}
                      onOptionTapped={this.handleOptionTapped}
                      onBackgroundTapped={this.toggleOpen}
                      onRequestClose={this.toggleOpen}
                      {...props}
                    />
                  </div>
                </div>
              </NoStyleButton>
              {infoIcon ? (
                <div style={styles.infoIconWrapper}>
                  <InfoIcon dialogText={infoText} />
                </div>
              ) : null}
            </div>
          );
        }}
      </Tappable>
    );
  }
}

export default withColorsProvider(SelectItem);



// WEBPACK FOOTER //
// ../nx-components/src/internal/SelectItem.jsx